import { z } from "zod/v4";
export const feedbackIssueTypeSchema = z.enum(["bug", "feature_request"]);
export const feedbackIssueStatusSchema = z.enum(["open", "resolved"]);
export const createFeedbackIssueInputSchema = z.object({
    title: z.string().min(1).max(200),
    description: z.string().max(10_000).optional().default(""),
    issue_type: feedbackIssueTypeSchema,
});
export const updateFeedbackIssueInputSchema = z.object({
    title: z.string().min(1).max(200).optional(),
    description: z.string().max(10_000).optional(),
    issue_type: feedbackIssueTypeSchema.optional(),
    status: feedbackIssueStatusSchema.optional(),
    is_archived: z.boolean().optional(),
});
export const createFeedbackCommentInputSchema = z.object({
    content: z.string().min(1).max(10_000),
});
export const updateFeedbackCommentInputSchema = z.object({
    content: z.string().min(1).max(10_000),
});
export const feedbackAttachmentInputSchema = z.object({
    name: z.string().min(1).max(255),
    type: z.string().min(1).max(120),
    size: z.number().int().nonnegative().max(50 * 1024 * 1024),
    base64: z.string().min(1),
});
